var eve = ''
var pagename = ''
var version = '' //版本
var pagetype = ''
export function Configuration(machine, page, py, ver) {
    pagetype = py || '活动'
    version = ver || ''
    if (machine == 'pc') {
        eve = 'Web'
        pagename = page
        zhuge.track(`Web_进入${pagetype}专题页`, {
            专题页名称: pagename,
            版本: version
        });
    } else if (machine == 'h5') {
        eve = 'H5'
        pagename = page
        zhuge.track(`H5_进入${pagetype}专题页`, {
            专题页名称: pagename,
            版本: version
        });
    }
}


export function mai(type, event, btnname) {
    if (type == 1) {
        window.zhuge.track(`${eve}_${pagetype}专题页_点击咨询`, {
            咨询按钮名称: event == null ? btnname : event.currentTarget.innerText,
            专题页名称: pagename,
            版本: version
        });
        qimoChatClick();
    } else if (type == 2) {
        window.zhuge.track(`${eve}_${pagetype}专题页_点击按钮`, {
            按钮名称: event == null ? btnname : event.currentTarget.innerText,
            专题页名称: pagename,
            版本: version
        });
    }
}